




































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserApi, User, UserAccess } from '@compassdigital/foodworks.ts.sdk';
import { cloneDeep } from 'lodash';
import { mixins } from 'vue-class-component';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import UserInformation from '@/components/Form/UserInformation/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import UserDeactivateModal from '@/components/Modal/UserDeactivateModal/index.vue';
import AccountActivation from '@/components/AccountActivation/index.vue';
import Format from '@/util/Format';
import moment from 'moment';
import SystemModule from '@/store/modules/system';
import { IUserDeactivateInfo, IUserInfo } from '@/interface/userInfo';
import ToastModule from '@/store/modules/toast';
import Service from '@/util/ServiceUtil';
import PermissionMixin from '../../../mixins/PermissionMixin';

@Component({
  components: {
    UserInformation,
    PrimaryButton,
    UserDeactivateModal,
    AccountActivation,
  },
})
export default class EditUser extends mixins(PermissionMixin) {
  private error: string = '';

  private scoutEmailID: string = '';

  private loading: boolean = false;

  private approverFw: boolean = false;

  get isCurrentUser() {
    const currentId = UserModule.currentUser ? UserModule.currentUser.id : null;
    return this.userInfo.id === currentId;
  }

  get approveStatus() {
    const currentId = UserModule.currentUser ? UserModule.currentUser.id : null;
    const approverStatus = UserModule.currentUser ? UserModule.currentUser.is : null;
    const emailID = UserModule.currentUser ? UserModule.currentUser.email : null;
    const currentUserRole = UserModule.currentRole;
    this.scoutEmailID = emailID as string;
    const disabledUser = this.userInfo.is.disabled;
    const { approver } = approverStatus as any;
    const approverUserStatus = approver && this.userInfo.id !== currentId && disabledUser === false;
    const adminApprover = currentUserRole === 'fw_admin' && this.userInfo.id !== currentId && disabledUser === false;
    if (approverUserStatus || adminApprover) {
      return true;
    }
    return false;
  }

  public currentDate() {
    const date = moment(this.userInfo.lastUpdatedAt).format('MMM. D, YYYY') || null;
    return date;
  }

  public currentTime() {
    const date = moment(this.userInfo.lastUpdatedAt).format('h:mma') || null;
    return date;
  }

  private isOpen: boolean = false;

  private lazy = false;

  public snackbar: boolean = false;

  public dialog: boolean = false;

  private errors: string = '';

  private userId: string = '';

  private userProfile: any = [];

  private saving: boolean = false;

  private userInfo: any = {
    id: '',
    title: '',
    name: {
      first: '',
      last: '',
    },
    lastUpdatedAt: null,
    email: '',
    contactNumber: {
      phone: '',
    },
    selectedRole: '',
    is: {
      disabled: '',
    },
    error: '',
    fName: '',
    lName: '',
    marketTypes: [],
  };

  private userInfoBackup: IUserInfo | null = null;

  private userValue:any = {
    deactivate: '',
    name: '',
    error: '',
  };

  public mounted() {
    this.getUserProfile();
  }

  public onMouseLeave() {
    this.isOpen = false;
  }

  public toggle() {
    this.isOpen = !this.isOpen;
  }

  // Getting the user profile
  public async getUserProfile() {
    try {
      if (AppModule.isLoggedIn && AppModule.accessToken) {
        try {
          const { id } = this.$route.params;
          const api = new UserApi(AppModule.apiConfig);
          const userDetails = await api.getUser(id);
          let userMarket = (await api.getUserAccessById(id)).data.marketId || [];
          const systemMarketIds = new Set(SystemModule.markets.map(e => e.id as string));
          userMarket = userMarket.filter(e => systemMarketIds.has(e));
          const user: any = userDetails.data;
          if (user.phone) {
            this.approverFw = user.is.approver;
            const { phone } = user.phone;
            const phoneNumber:any = Format.maskPhoneNumber(phone);
            this.userInfo.contactNumber.phone = phoneNumber;
          }
          if (user) {
            this.userInfo = {
              role: user.permissions.scopes[0] || '',
              // eslint-disable-next-line
              lastUpdatedAt: user._lastUpdatedDate || null,
              id: user.id || '',
              name: {
                first: user.name!.first || '',
                last: user.name!.last || '',
              },
              email: user.email || '',
              contactNumber: this.userInfo.contactNumber || '',
              selectedRole: user.permissions.scopes[0] || '',
              fName: Format.getFormattedName(user),
              is: user.is || { disabled: true },
            };
            this.userInfo.marketTypes = userMarket;
            this.userValue.name = this.userInfo.fName;
            this.userInfoBackup = cloneDeep(this.userInfo);
          }
        } catch (err) {
          throw err;
        }
      }
    } catch (err) {
      if (err.error) {
        this.errors = err.error;
      }
    }
  }

  // Updating the user profile
  public async onEditUser() {
    if ((this.$refs.form as any).validate()) {
      try {
        this.loading = true;
        if (AppModule.isLoggedIn && AppModule.accessToken) {
          const { id } = this.$route.params;
          const userId = id;

          // Removing the masking of phone number
          if (this.userInfo.contactNumber) {
            const { phone } = this.userInfo.contactNumber;
            this.userInfo.contactNumber.phone = Format.CheckMaskNumber(phone);
          }

          if (this.accessLimitUser) {
            this.userInfo.is.approver = false;
          }

          const marketApiAccess: UserAccess = ({
            marketId: this.userInfo.marketTypes,
          });

          const userData: User = {
            id: userId,
            name: this.userInfo.name,
            email: this.userInfo.email,
            phone: this.userInfo.contactNumber,
            permissions: {
              scopes: [this.userInfo.selectedRole],
            },
            is: this.userInfo.is,
          };
          try {
            const api = new UserApi(AppModule.apiConfig);
            const user: any = await api.patchUser(userId, userData);
            if (this.userInfo.selectedRole === 'fw_manager') {
              const marketFetched = await api.patchUserAccessById(userId, marketApiAccess);
            }
            const { data } = user;
            let message = 'Changes saved';
            if (data) {
              const { name } = data;
              const { first, last } = name;
              message = `${first} ${last} Changes saved`;
            }
            this.$router.push({ name: 'users', params: { message } });
          } catch (err) {
            throw err;
          }
        }
      } catch (err) {
        if (err) {
          this.userInfo.error = err.response.data.error.message;
        }
      }
      this.loading = false;
    }
  }

  public async openUserModal() {
    this.dialog = true;
  }

  public async onSubmitDeactivate() {
    const { id } = this.$route.params;
    const userId = id;
    const userData: IUserDeactivateInfo = {
      is: {
        disabled: true,
        deactivatedBy: this.scoutEmailID,
      },
    };
    this.saving = true;

    try {
      const api = new UserApi(AppModule.apiConfig);
      const user: any = await api.patchUser(userId, userData);
      const { deactivatedBy } = user.data.is;
      const { data } = user;
      this.userInfo.is.disabled = true;
      this.userInfo.is.deactivatedBy = deactivatedBy;
      this.dialog = false;
      this.userInfo.lastUpdatedAt = new Date();
    } catch (err) {
      const error = err.response.data.error.message;
      if (error === 'Not Authorized') {
        this.userValue.error = 'FW manger do not have permission to deactivate an admin users';
      } else {
        this.userInfo.error = error;
      }
    }
    this.saving = false;
  }

  public async close() {
    this.dialog = false;
  }

  public async sendInvitation() {
    this.loading = true;
    const user: any = await Service.sendInvitation(this.userInfo.email as string);
    if (user.status === 200) {
      ToastModule.setToast({
        message: 'Sign up invitation has been sent',
        timeout: 5000,
      });
    } else {
      this.errors = user.errorMessage;
    }
    this.loading = false;
  }

  public cancel() {
    this.$router.push('/users');
  }

  public get accessLimitUser() {
    if (this.userInfo.selectedRole === 'partner_owner'
    || this.userInfo.selectedRole === 'unit_manager'
    ) {
      return true;
    }
    return false;
  }
}
